export enum BookingsConfigEnum {
    All,
    Active,
    Cancelled,
    Completed
}